import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-badges" aria-label="Social and community badges">
        <img
          className="footer-van"
          src="/Moving-Van_00001.gif"
          alt="Moving van animation"
        />
        <div className="footer-socials">
          <a
            href="https://www.instagram.com/megavoltelectric?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Megavolt Electric on Instagram"
            title="Instagram"
          >
            <img
              src="/Platform=Instagram, Color=Negative.png"
              alt="Instagram (negative style)"
            />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100086212904947"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Megavolt Electric on Facebook"
            title="Facebook"
          >
            <img
              src="/Platform=Facebook, Color=Negative.png"
              alt="Facebook (negative style)"
            />
          </a>
          <a
            href="https://ca.nextdoor.com/page/megavolt-electric-ltd-calgary-alberta?utm_campaign=1758884976967&share_action_id=6d995d86-c973-470d-aa7e-ea1213c63db2"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Megavolt Electric on Nextdoor"
            title="Nextdoor"
          >
            <img
              src="/logo-nextdoor-house-lawn-(1)-1.png"
              alt="Nextdoor logo"
            />
          </a>
        </div>
      </div>
      <p>&copy; {new Date().getFullYear()} MegaVolt Electric. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
